import { render } from "./ProductFeedbackContainer.vue?vue&type=template&id=6433fb07"
import script from "./ProductFeedbackContainer.vue?vue&type=script&lang=js"
export * from "./ProductFeedbackContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__